import { CampaignObject } from "../types/APITypes";
import { usePost } from "./requestAPI/apiPost";


type FormSubmissionResponse = {
    result: string;
}

type UsePostFormSubmissionResponse = [
    (data: CampaignObject) => Promise<FormSubmissionResponse | null>,
    {
        value?: FormSubmissionResponse;
        loading: boolean;
        called: boolean;
        error?: string;
        isSuccess: boolean;
    }
]

export const usePostFormSubmission = (): UsePostFormSubmissionResponse => {
    
    const [post, postState] = usePost<FormSubmissionResponse, CampaignObject>({
        url: `intake-form/post-form-data`
    })

    const submitForm = async (
        data : CampaignObject
    ) : Promise<FormSubmissionResponse | null> => {

        const result = await post(data);
        return result;
    }

    return [submitForm, postState];
};